export enum TabId {
	QuickView = 'QuickView',
	DetailedView = 'DetailedView',
}

export type TabItemModel = {
	tabId: TabId;
	label: string;
};
